// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/entity.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Value } from "./value_pb.js";

/**
 * Represents a generic holder for different ML backend specific key value
 * pairs.
 * The keys should identify the ML backend (and where relevant for
 * backward/forward compatibility
 * also a version) such as, e.g, "dai/resumed_experiment" or
 * "dai:1.5.1/model_parameters".
 *
 * @generated from message ai.h2o.storage.Metadata
 */
export const Metadata = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Metadata",
  () => [
    { no: 1, name: "values", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Value} },
  ],
);

